import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styles from '../styles/buttons.module.css';
import { faArrowUp } from '@fortawesome/free-solid-svg-icons';
import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTopButton = () => {
    const [isVisible,setisVisible] = useState(false);
    const [isMobile, setIsMobile] = useState(false);
    const location = useLocation();

    useEffect(() => {
        const mediaQueryList = window.matchMedia('(max-width: 991.98px)');

        const updateMatches = (event) => {
            setIsMobile(event.matches);
        };

        setIsMobile(mediaQueryList.matches);
        mediaQueryList.addEventListener('change', updateMatches);

        return () => {
            mediaQueryList.removeEventListener('change', updateMatches);
        };
    }, []);

    useEffect(() => {
        const toggleVisibility = () => {
            if(window.scrollY > 300){
                setisVisible(true);
            }
            else{
                setisVisible(false);
            }
        }

        window.addEventListener('scroll',toggleVisibility);

        return () => {
            window.removeEventListener('scroll',toggleVisibility);
        }
    },[])

    const isClientApplicationRoute = /^\/client\/applications\/[^/]+(\/.*)?$/i.test(location.pathname);
    const isManageGroupAppRoute = /^\/admin\/managegroupapp\/?$/i.test(location.pathname);

    if (isMobile && (isClientApplicationRoute || isManageGroupAppRoute)) {
        return null;
    }

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        })
    }

    return(
        <button type='button' className={`semanticBtnOverride ${styles.scrollToTopButton} ${!isVisible ? styles.hide : ''}`} onClick={() => scrollToTop()} aria-label='Scroll To Top'>
            <span className={styles.icon}>
                <FontAwesomeIcon icon={faArrowUp} size="lg"/>
            </span>
        </button>
    )
}

export default ScrollToTopButton;
